import React from "react";
import {
  Box,
  Container,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";

import AdminPage from "./AdminPage";
import ProductShippingMetadataTable from "../../components/backend/productshippingmetadata/ProductShippingMetadataTable";

const ProductShippingMetadataPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <AdminPage>
      <Container maxWidth="xl">
        <Box sx={{ mb: 4 }}>
          <Typography variant="h4" gutterBottom sx={{ fontWeight: 700 }}>
            {t("admin.shippingMetadata.title")}
          </Typography>
          <Typography variant="body1" color="text.secondary">
            {t("admin.shippingMetadata.subtitle")}
          </Typography>
        </Box>

        <ProductShippingMetadataTable />
      </Container>
    </AdminPage>
  );
};

export default ProductShippingMetadataPage;

